// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderMobileActionsDialog_container__1OvVK","action":"HeaderMobileActionsDialog_action__32B5j"};